'use client';

import React from 'react';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import UkassaTarget from '../reusable-components/layouts-components__ukassa/target';
import UkassaTasks from '../reusable-components/layouts-components__ukassa/tasks';
import UkassaProcess from '../reusable-components/layouts-components__ukassa/process';
import UkassaJob from '../reusable-components/layouts-components__ukassa/job';
import UkassaResult from '../reusable-components/layouts-components__ukassa/result';
import UkassaTeam from '../reusable-components/layouts-components__ukassa/team';
import UkassaOutput from '../reusable-components/layouts-components__ukassa/output';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import CommonSmallText from '../common-components/common-small-text';
import CommonSmallTitle from '../common-components/common-small-title';

const upgreatMainTitle = {
    titleMainText: `ЮКаssа: битва за трафик после ребрендинга`,
    titleAnimation: '/images/png/ukassa.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#16BE96',
            nameText: 'ЮКаssа',
        },
        {
            modeText: 'Услуги',
            colorMode: '#16BE96',
            nameText: 'SEO: аудит, разработка стратегии',
        },
    ],
};

const nextProjectUpgreat = {
    nextProjectTitle:
        'Продвижение сообщества AdventureLand Технопарка «Сколково» на венчурном рынке',
    nextProjectImg: '/images/pic/preview/AdventureLand.png',
    nextProjectLink: '/cases/marketing/adventureland',
    nextProjectLinkTitle: 'Технопарк «Сколково»',
    nextProjectText:
        'Как мы работаем, чтобы AdventureLand стал крупнейшим сообществом, в котором стартапы получают инвестиции: рекламные кампании для сложного венчурного рынка.',
};

const UkassaLanding = () => {
    return (
        <section className="ukassa-landing">
            <div className="ukassa__title-wrap">
                <MainTitle MainTitle={upgreatMainTitle}>
                    <CommonSmallTitle className="ukassa__subtitle">
                        <img
                            src="/images/svg/ukassa/ukassa-logo.svg"
                            alt=""
                            className="ukassa__subtitle-img"
                            loading="lazy"
                        />
                    </CommonSmallTitle>
                    <CommonSmallText>
                        SEO проекта наша команда занималась с мая 2019 года. Основные метрики,
                        которые мы обслуживаем: позиции и небрендовый трафик. В конце 2020 года
                        проект по решению клиента перенесли на другой домен. Нам предстояло решить
                        сложную и стратегически важную задачу — сохранить небрендовый трафик и при
                        этом минимизировать потери позиций в поисковой выдаче.{' '}
                    </CommonSmallText>
                </MainTitle>
            </div>

            <UkassaTarget />

            <UkassaTasks />

            <UkassaProcess />

            <UkassaJob />

            <UkassaResult />

            <UkassaOutput />

            <UkassaTeam />

            <NextProject NextProject={nextProjectUpgreat} />
        </section>
    );
};

export default UkassaLanding;
